import { GeoJsonEditMode } from './geojson-edit-mode';

export class ViewMode extends GeoJsonEditMode {}
